import { css as t } from "@lokalise/styled";
import { value as o } from "../theme/index.js";
const i = t`
	cursor: pointer;
	font-size: inherit;
	font-weight: inherit;
	line-height: inherit;
	color: ${o("color.text.link.default")};
	transition: color ${o("motion.speed.1")};
	background-color: transparent;
	padding: 0;
	border: none;
	font-family: ${o("font.family.default")};

	&:hover,
	&:focus,
	&:active,
	&:active:hover {
		color: ${o("color.text.link.hover")};
	}
`;
export {
  i as withLinkStyle
};
//# sourceMappingURL=link.js.map
